export const breakpointExtraSmall = '360px';
export const breakpointSmall = '767px';
export const breakpointMedium = '991px';
export const breakpointLarge = '1440px';
export const breakpointExtraLarge = '1920px';
